import { defineMessages } from '@jutro/locale';

export default defineMessages({
    policyDiffTitle: {
        id: 'endorsement.common.views.history.Policy Changes',
        defaultMessage: 'Policy Changes'
    }
});
